import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useAvatars() {
  const [avatars, setAvatars] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    axios
      .get(routes.api.super_admins.avatars.index)
      .then((response) => {
        setAvatars(response.data.data);
      });
  }, [shouldRefetch]);

  return { avatars, refresh };
}
